import dict from 'locales/dict';
import { FacebookIcon, LinkedinIcon, MapPinIcon } from 'lucide-react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import vacsLogo from 'assets/images/vacs-logo.png';
import { ENDPOINTS } from 'utils/endpoints';
import { Link } from 'react-router-dom';
import { PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

const FooterComponent = () => {
  const { t } = useTranslation();
  const data = [
    {
      title: 'Company',
      links: [
        { title: 'About us', href: ENDPOINTS.aboutUs },
        { title: 'Our team', href: ENDPOINTS.aboutUs },
        { title: 'Our services', href: ENDPOINTS.aboutUs },
        // { title: 'Our vision', href: ENDPOINTS.missionVision },
        // { title: 'Our value', href: ENDPOINTS.ourValue },
      ],
    },
    {
      title: 'Gallery',
      links: [
        { title: 'Construction progress & Facility', href: `${ENDPOINTS.mediaGalery}` },
        // { title: 'Facility', href: `${ENDPOINTS.mediaGalery}?tab=EQUIPMENT` },
        // { title: 'Training', href: `${ENDPOINTS.mediaGalery}?tab=TRAINING` },
        { title: 'Achievements', href: `${ENDPOINTS.achievements}` },
      ],
    },
    {
      title: 'Contact Us',
      links: [
        { title: 'Careers', href: ENDPOINTS.career },
        { title: '(+84) 28-3844-8367', icon: PhoneIcon },
        { title: 'info@vnaircaterers.com', icon: EnvelopeIcon },
      ],
    },
  ];

  return (
    <footer className='px-4 md:px-16 lg:px-24 text-[13px] pt-12 text-white bg-brand-secondary'>
      <div className='grid grid-cols-1 lg:grid-cols-7 items-start min-md:justify-between gap-10'>
        <a href='https://vnaircaterers.com/' className='col-span-1 md:col-span-1'>
          <img
            src={vacsLogo}
            alt='Logo'
            className='h-[4.11rem] w-auto object-cover contrast-[1.1] drop-shadow-[0_0_4px_rgba(50,50,50,0.8)]'
          />
        </a>

        <div className='text-white text-justify col-span-1 lg:col-span-3 text-base'>
          <h2 className='font-semibold'>Locations</h2>
          <ul className='mt-5 space-y-4 pr-4'>
            <li
              className='flex gap-x-3 cursor-pointer hover:text-cyan-300'
              onClick={() => window.open('https://maps.app.goo.gl/ToNC46DtAZ5KMRcM8', '_blank')}
            >
              <MapPinIcon className='min-w-4' />
              Tan Son Nhat International Airport, Tan Son Hoa Ward, Ho Chi Minh City, Vietnam
            </li>
            <li
              className='flex gap-x-3 cursor-pointer hover:text-cyan-300'
              onClick={() => window.open('https://maps.app.goo.gl/ZhfZzj36K46epA496', '_blank')}
            >
              <MapPinIcon className='min-w-4' />
              <span>Phu Quoc International Airport, Phu Quoc Special Zone. An Giang Province, Vietnam</span>
            </li>
            <li
              className='flex gap-x-3 cursor-pointer hover:text-cyan-300'
              onClick={() => window.open('https://maps.app.goo.gl/EaRnFUSkP15yFHjp9', '_blank')}
            >
              <MapPinIcon className='min-w-4' />
              <span>Long Thanh International Airport, Long Thanh Ward, Dong Nai Province, Vietnam</span>
            </li>
          </ul>
        </div>

        {data.map((item, index) => (
          <div key={index} className='col-span-1 text-base'>
            <p className='font-semibold text-white'>{item.title}</p>
            <ul className='mt-5 space-y-2'>
              {item.links.map((link: any, idx: number) => (
                <li key={`sub-${idx}`} className='flex gap-x-3 hover:text-cyan-300 transition'>
                  {link?.icon ? <link.icon className='hidden lg:block size-5 text-white mt-1' /> : <></>}
                  <span>
                    {link?.href ? (
                      <Link to={link.href}>{link.title}</Link>
                    ) : (
                      <span className='w-full'>{link.title}</span>
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className='flex flex-col md:flex-row py-7 my-6 border-gray-200 md:justify-between max-md:items-center border-t max-md:text-center gap-4 items-end  text-base'>
        <p className='text-center'>
          {`Copyright © ${new Date().getFullYear()} ${t(dict.vietnamAirlinesCaterers)} | ${t(dict.allRightsReserve)}.`}
        </p>
        <div className='flex items-center gap-4'>
          <a href='https://www.linkedin.com/company/vnaircaterers' target='_blank' rel='noreferrer'>
            <LinkedinIcon className='size-5 text-white hover:text-cyan-300' />
          </a>
          <a href='https://www.facebook.com/LOTUSChef.VACS/' target='_blank' rel='noreferrer'>
            <FacebookIcon className='size-5 text-white hover:text-cyan-300' />
          </a>
          {/* <a href='https://x.com/vacs' target='_blank' rel='noreferrer'>
            <TwitterIcon className='size-5 text-white hover:text-cyan-300' />
          </a>
          <a href='https://www.youtube.com/@vacs' target='_blank' rel='noreferrer'>
            <YoutubeIcon className='size-6 text-white hover:text-cyan-300' />
          </a> */}
        </div>
      </div>
    </footer>
  );
};

export const Footer = memo(FooterComponent);
